import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Location} from '@angular/common';
import {OcrService} from '../../../components/ocr/ocr.service';
import {OcrFileinfo} from '../../../domain/model/common/file/ocr-file-info.class';

import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import moment = require('moment');
import {isUndefined} from 'util';
import {FormErrors} from '../../../components/forms/validation/form-validator.class';
import {CountryService} from '../../../domain/model/info/country/country.service';
import {MonthPickerComponentModel} from '../../../components/forms/controls/monthpicker/month-picker.component';
import {Work} from '../../../domain/model/work/history/work.model';
import {AddressModel} from '../../../components/forms/controls/addresspicker/addresspicker.component';
import {AddressMapper} from '../../../domain/model/common/mappers/address-mapper.class';
import {Address} from '../../../domain/model/common/values/address.class';
import {WorkDuration} from '../../../domain/model/common/values/work-duration.class';
import {
    FormManager,
    FormSubmissionStatusCode,
    FormSubmissionStatusReason
} from '../../../components/forms/form-manager.class';
import {Observable} from 'rxjs/Observable';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from '../../../../../node_modules/rxjs';
import {WorkService} from '../../../domain/model/work/history/work.service';


export class WorkData {
    public data: Work = new Work();
    public count: number = -1;
}

enum NextScreenTransitioningStatus {
    NOT_TRANSITIONING = 1,
    TRANSITIONING
}

@Component({
    template: require('./files-work-page.component.html'),
    styles: [require('./files-work-page.component.scss')],
})
export class FilesWorkPageComponent implements OnInit, OnDestroy {

    file: OcrFileinfo;

    formErrors: FormErrors = {};

    workEntries: WorkData[] = [];

    private id: string;
    private entryIndex: number = 0;

    private sub: any;
    private subRouter: any;

    states: Array<string> = [];
    usStates: Array<string> = [];
    canadaProvinces: Array<string> = [];
    countries: Array<string> = [];
    model: WorkData;
    originalContent: string = '';
    page = 0;
    total = 0;
    loading: boolean = false;

    positionHeldOptions = [
        '',
        'Active-Physician',
        'Inactive-Physician',
        'Temp-Physician',
        'Director/Supervisor',
        'Administrative',
        'Research'
    ];

    phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    durationDateConstrains = {
        minDate: moment().subtract(100, 'year'),
        maxDate: moment().add(1, 'year')
    };
    durationFromMonthPickerModel = new MonthPickerComponentModel(this.durationDateConstrains);
    durationToMonthPickerModel = new MonthPickerComponentModel(this.durationDateConstrains);

    nextScreenTransitioningStatuses = NextScreenTransitioningStatus;

    nextScreenTransitioningStatus: NextScreenTransitioningStatus = NextScreenTransitioningStatus.NOT_TRANSITIONING;

    private readonly _addressMapper = new AddressMapper();

    readonly _form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm)
    set form(value: NgForm) {
        this._form$.next(value);
    }

    private readonly _formManager: FormManager<any>;

    constructor(protected ocrService: OcrService,
                readonly route: ActivatedRoute,
                protected countryService: CountryService,
                fmgm: FormManager.InjectedMembers,
                readonly workService: WorkService,
                private readonly _router: Router,
                private readonly _location: Location
                ) {
        this._formManager = new FormManager(
            fmgm,
            this._form$.asObservable(),
            Observable.of(() => workService.updateCurrentUserModelEntry(this.model.count, this.model.data)),
            undefined,
            false
        );
    }

    ngOnInit(): void {
        this.model = new WorkData();
        this.model.data.duration.upToPresent = false;
        this.model.data.clinicalPosition = false;
        this._formManager.displayedErrors$.subscribe(errors => this.formErrors = errors);

        this.sub = this.route.params.subscribe(params => {
            const entryIndex = params['entry'];
            this.id = params['id'];
            this.entryIndex = entryIndex ? parseInt(entryIndex, 10) - 1 : 0;
        });
        this.subRouter = this._router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.loadContent(this.id, this.entryIndex);
            }
        });
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
        this.subRouter.unsubscribe();
    }

    loadContent(id: string, entryIndex: number) {
        this.loading = true;
        //states and country info must be loaded first, then show entry data
        Observable.forkJoin(
            this.countryService.getStates(),
            this.countryService.getStatesForCountry('US'),
            this.countryService.getStatesForCountry('CA'),
            this.countryService.getCountriesProjection(),
            this.ocrService.file(id)
        ).subscribe(responses => {
            this.states = responses[0].map(s => s.name);
            this.usStates = responses[1].map(s => s.name);
            this.canadaProvinces = responses[2].map(s => s.name);
            this.countries = responses[3].map(c => c.name);
            this.file = responses[4];
            this.total = responses[4].parsingData.workHistory.length;
            this.showWorkEntry(entryIndex);
            this.loading = false;
        });
    }

    showWorkEntry(entry: number) {
        let workEntry = this.file.parsingData.workHistory[entry];
        if (this.workEntries.length > entry) {
            this.model = this.workEntries[entry];
            this._form$.asObservable().first().subscribe(ngForm => ngForm.form.markAsDirty());
        } else {
            this.model = new WorkData();
            this.page = entry;
            if (workEntry.facility.length > 0) {
                this.model.data.facility = workEntry.facility[0];
            }
            let address = new Address();
            address.address1 = workEntry.street;
            address.city = workEntry.city;
            address.stateOrProvince = workEntry.state;
            if (this.usStates.indexOf(workEntry.state) > -1) {
                address.country = 'United States';
            } else if (this.canadaProvinces.indexOf(workEntry.state) > -1) {
                address.country = 'Canada';
            }
            address.postalCode = workEntry.zipCode;
            this.model.data.address = address;
            let workDuration = new WorkDuration();
            workDuration.from = workEntry.from;
            workDuration.to = workEntry.to;
            workDuration.upToPresent = !isUndefined(workEntry);
            this.model.data.duration = workDuration;
            this.model.data.clinicalPosition = false;
            this.model.count = -1;
            this.workEntries.push(this.model);
            this._form$.asObservable().first().subscribe(ngForm => ngForm.form.markAsDirty());
        }
        if (!isUndefined(this.originalContent)) {
            this.originalContent = workEntry.originalContent.join('\n');
        }
    }

    handleAddressUpdated(addressModel: AddressModel) {
        this._addressMapper.update(this.model.data.address, addressModel);
    }

    handleStateUpdated() {

        let state = this.model.data.address.stateOrProvince;
        if (state != null) {
            if (this.usStates.indexOf(state) > -1) {
                this.model.data.address.country = 'United States';
            } else if (this.canadaProvinces.indexOf(state) > -1) {
                this.model.data.address.country = 'Canada';
            }
        }
    }

    handleUpToPresentDurationChange() {
        if (this.model.data.duration.upToPresent) this.model.data.duration.to = undefined;
    }

    hasPreviousScreen(): boolean {
        return this.page > 0;
    }

    goToPreviousScreen() {
        if (this.hasPreviousScreen() && this.nextScreenTransitioningStatus === NextScreenTransitioningStatus.NOT_TRANSITIONING) {
            let url = this._router.createUrlTree(['', 'resume', 'work', this.id, this.page]).toString();
            this.nextScreenTransitioningStatus = NextScreenTransitioningStatus.TRANSITIONING;
            this.page = this.page - 1;
            this.showWorkEntry(this.page);
            this.nextScreenTransitioningStatus = NextScreenTransitioningStatus.NOT_TRANSITIONING;
            this._location.go(url);
        }
    }

    hasNextScreen(): boolean {
        if (this.file) {
            return this.file.parsingData.workHistory.length > 1 && (this.page + 1) < this.file.parsingData.workHistory.length;
        } else {
            return false;
        }
    }

    goToNextScreen() {
        if (this.hasNextScreen() && this.nextScreenTransitioningStatus === NextScreenTransitioningStatus.NOT_TRANSITIONING) {
            this.nextScreenTransitioningStatus = NextScreenTransitioningStatus.TRANSITIONING;
            this.page = this.page + 1;
            this.showWorkEntry(this.page);
            this.nextScreenTransitioningStatus = NextScreenTransitioningStatus.NOT_TRANSITIONING;
            let url = this._router.createUrlTree(['', 'resume', 'work', this.id, this.page + 1]).toString();
            this._location.go(url);
        }  else {
            this._router.navigate(['', 'resume', 'view', this.id]);
        }
    }

    saveAndSkip() {
        this.nextScreenTransitioningStatus = NextScreenTransitioningStatus.TRANSITIONING;
        if (this.model.count === -1) {
            this.workService.countCurrentUserModelEntries()
                .subscribe(count => {
                    this.model.count = count + 1;
                    this.save();
                });
        } else {
            this.save();
        }
    }

    save() {
        this._formManager.save(false, true).subscribe(result => {
            const resultStatus = result.status;
            this.nextScreenTransitioningStatus = NextScreenTransitioningStatus.NOT_TRANSITIONING;
            if (resultStatus.code === FormSubmissionStatusCode.SUBMITTED) {
                this.goToNextScreen();
            }
            else if (resultStatus.code === FormSubmissionStatusCode.NOTSUBMITTED) {
                if (resultStatus.reason === FormSubmissionStatusReason.NOT_DIRTY) {
                    this._formManager.hasErrors$.first().subscribe(hasErrors => {
                        if (!hasErrors) {
                            this.goToNextScreen();
                        }
                    });
                }
            } else {
                this._handleBackendError(result);
                this.nextScreenTransitioningStatus = NextScreenTransitioningStatus.NOT_TRANSITIONING;
            }
        });
    }

    private _handleBackendError(result) {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/resume/work/files-work-page.component.ts